import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ResultData } from 'src/app/_models/ResultData';
import { SubTopicService } from 'src/app/_services/subTopic.service';

@Component({
  selector: 'app-search-sub-topic',
  templateUrl: './search-sub-topic.component.html',
  styleUrls: ['./search-sub-topic.component.css']
})
export class SearchSubTopicComponent implements OnInit {

  subtopicList=[]


  searchTemplateForm:FormGroup =undefined
  constructor(
    private subTopicService:SubTopicService
  ) {

  }

  ngOnInit(): void {
    this.initForm()
    this.onChanges()

  }

  initForm(){
   this.searchTemplateForm= new FormGroup(
      {'searchInput': new FormControl('')}
      )
  }


  onChanges(): void {
    this.searchTemplateForm.get('searchInput').valueChanges.subscribe(val => {
      if(val.length>2){

        this.subTopicService.searchSubTopicAll(val).subscribe(
          {
            next:(data:ResultData)=>{
              this.subtopicList=data.rs.data
            }
          }

        )
    }else{
      this.subtopicList=[]
    }
  })
}




}
